/* eslint-disable no-param-reassign */
import Fetch, { V1 } from 'Util/fetcher';

//= ==================================================================================//
//                    GET TRANSACTION STOCK LIST                                      //
//= ==================================================================================//

const ON_REQUEST_TRANSACTION_STOCK = 'ON_REQUEST_TRANSACTION_STOCK';
const ON_REQUEST_TRANSACTION_STOCK_SUCCESS = 'ON_REQUEST_TRANSACTION_STOCK_SUCCESS';
const ON_REQUEST_TRANSACTION_STOCK_FAILURE = 'ON_REQUEST_TRANSACTION_STOCK_FAILURE';

function onRequestTransactionStock(resetData) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK,
    meta: { resetData },
  };
}

function onRequestTransactionStockSuccess(payload, resetData) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_SUCCESS,
    meta: { resetData },
    payload,
  };
}

function onRequestTransactionStockFailure(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestTransactionStock = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestTransactionStock(resetData || false));
  Fetch.get(`${V1}stock/orderlist-filter/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(
          onRequestTransactionStockSuccess(
            resp.json,
            resetData || false
          )
        );
      } else {
        dispatch(onRequestTransactionStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestTransactionStockFailure(error.message));
    });
};

//= ==================================================================================//
//                         GET TRANSACTION STOCK LIST  OPEN                           //
//= ==================================================================================//

const ON_REQUEST_TRANSACTION_STOCK_OPEN = 'ON_REQUEST_TRANSACTION_STOCK_OPEN';
const ON_REQUEST_TRANSACTION_STOCK_OPEN_SUCCESS = 'ON_REQUEST_TRANSACTION_STOCK_OPEN_SUCCESS';
const ON_REQUEST_TRANSACTION_STOCK_OPEN_FAILURE = 'ON_REQUEST_TRANSACTION_STOCK_OPEN_FAILURE';

function onRequestTransactionStockOpen(resetData) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_OPEN,
    meta: { resetData },
  };
}

function onRequestTransactionStockOpenSuccess(payload, resetData) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_OPEN_SUCCESS,
    meta: { resetData },

    payload,
  };
}

function onRequestTransactionStockOpenFailure(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_OPEN_FAILURE,
    payload,
  };
}

export const onDoRequestTransactionStockOpen = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestTransactionStockOpen(resetData || false));
  Fetch.get(`${V1}stock/orderlist-filter/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(
          onRequestTransactionStockOpenSuccess(
            resp.json,
            resetData || false
          )
        );
      } else {
        dispatch(onRequestTransactionStockOpenFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestTransactionStockOpenFailure(error.message));
    });
};

//= ==================================================================================//
//                             GET TRANSACTION STOCK DETAIL                           //
//= ==================================================================================//

const ON_REQUEST_TRANSACTION_STOCK_DETAIL = 'ON_REQUEST_TRANSACTION_STOCK_DETAIL';
const ON_REQUEST_TRANSACTION_STOCK_DETAIL_SUCCESS = 'ON_REQUEST_TRANSACTION_STOCK_DETAIL_SUCCESS';
const ON_REQUEST_TRANSACTION_STOCK_DETAIL_FAILURE = 'ON_REQUEST_TRANSACTION_STOCK_DETAIL_FAILURE';

function onRequestTransactionStockDetail() {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_DETAIL,
  };
}

function onRequestTransactionStockDetailSuccess(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_DETAIL_SUCCESS,
    payload,
  };
}

function onRequestTransactionStockDetailFailure(payload) {
  return {
    type: ON_REQUEST_TRANSACTION_STOCK_DETAIL_FAILURE,
    payload,
  };
}

export const onDoRequestTransactionStockDetail = payload => (dispatch) => {
  dispatch(onRequestTransactionStockDetail());
  Fetch.get(`${V1}stock/orderlist/${payload}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestTransactionStockDetailSuccess(resp.json));
      } else {
        dispatch(onRequestTransactionStockDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestTransactionStockDetailFailure(error.message));
    });
};

//= ==================================================================================//
//                             GET HISTORY STOCK LIST                                 //
//= ==================================================================================//

const ON_REQUEST_HISTORY_STOCK = 'ON_REQUEST_HISTORY_STOCK';
const ON_REQUEST_HISTORY_STOCK_SUCCESS = 'ON_REQUEST_HISTORY_STOCK_SUCCESS';
const ON_REQUEST_HISTORY_STOCK_FAILURE = 'ON_REQUEST_HISTORY_STOCK_FAILURE';

function onRequestHistoryStock(resetData) {
  return {
    type: ON_REQUEST_HISTORY_STOCK,
    meta: { resetData },
  };
}

function onRequestHistoryStockSuccess(payload) {
  return {
    type: ON_REQUEST_HISTORY_STOCK_SUCCESS,
    payload,
  };
}

function onRequestHistoryStockFailure(payload) {
  return {
    type: ON_REQUEST_HISTORY_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestHistoryStock = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestHistoryStock(resetData));
  Fetch.get(`${V1}stock/historytrade-filter/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHistoryStockSuccess(resp.json));
      } else {
        dispatch(onRequestHistoryStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHistoryStockFailure(error.message));
    });
};

//= ==================================================================================//
//                             GET HISTORY STOCK DETAIL                               //
//= ==================================================================================//

const ON_REQUEST_HISTORY_STOCK_DETAIL = 'ON_REQUEST_HISTORY_STOCK_DETAIL';
const ON_REQUEST_HISTORY_STOCK_DETAIL_SUCCESS = 'ON_REQUEST_HISTORY_STOCK_DETAIL_SUCCESS';
const ON_REQUEST_HISTORY_STOCK_DETAIL_FAILURE = 'ON_REQUEST_HISTORY_STOCK_DETAIL_FAILURE';

function onRequestHistoryStockDetail() {
  return {
    type: ON_REQUEST_HISTORY_STOCK_DETAIL,
  };
}

function onRequestHistoryStockDetailSuccess(payload) {
  return {
    type: ON_REQUEST_HISTORY_STOCK_DETAIL_SUCCESS,
    payload,
  };
}

function onRequestHistoryStockDetailFailure(payload) {
  return {
    type: ON_REQUEST_HISTORY_STOCK_DETAIL_FAILURE,
    payload,
  };
}

export const onDoRequestHistoryStockDetail = payload => (dispatch) => {
  dispatch(onRequestHistoryStockDetail());
  Fetch.get(
    `${V1}stock/historytrade-filter/${payload.id}/?start_date=${payload.date}`
  )
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHistoryStockDetailSuccess(resp.json));
      } else {
        dispatch(onRequestHistoryStockDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHistoryStockDetailFailure(error.message));
    });
};

//= ==================================================================================//
//                              CANCEL STOCK ORDER                                    //
//= ==================================================================================//

const ON_REQUEST_CANCEL_ORDER = 'ON_REQUEST_CANCEL_ORDER';
const ON_REQUEST_CANCEL_ORDER_SUCCESS = 'ON_REQUEST_CANCEL_ORDER_SUCCESS';
const ON_REQUEST_CANCEL_ORDER_FAILURE = 'ON_REQUEST_CANCEL_ORDER_FAILURE';

function onRequestCancelOrder() {
  return {
    type: ON_REQUEST_CANCEL_ORDER,
  };
}

function onRequestCancelOrderSuccess(payload) {
  return {
    type: ON_REQUEST_CANCEL_ORDER_SUCCESS,
    payload,
  };
}

function onRequestCancelOrderFailure(payload) {
  return {
    type: ON_REQUEST_CANCEL_ORDER_FAILURE,
    payload,
  };
}

export const onDoRequestCancelOrder = payload => (dispatch) => {
  dispatch(onRequestCancelOrder());
  Fetch.post(`${V1}stock/withdraw/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestCancelOrderSuccess(resp.json));
      } else {
        dispatch(onRequestCancelOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestCancelOrderFailure(error.message));
    });
};

//= ==================================================================================//
//                                 CANCEL STOCK ORDER                                 //
//= ==================================================================================//

const ON_REQUEST_AMEND_ORDER = 'ON_REQUEST_AMEND_ORDER';
const ON_REQUEST_AMEND_ORDER_SUCCESS = 'ON_REQUEST_AMEND_ORDER_SUCCESS';
const ON_REQUEST_AMEND_ORDER_FAILURE = 'ON_REQUEST_AMEND_ORDER_FAILURE';

function onRequestAmendOrder() {
  return {
    type: ON_REQUEST_AMEND_ORDER,
  };
}

function onRequestAmendOrderSuccess(payload) {
  return {
    type: ON_REQUEST_AMEND_ORDER_SUCCESS,
    payload,
  };
}

function onRequestAmendOrderFailure(payload) {
  return {
    type: ON_REQUEST_AMEND_ORDER_FAILURE,
    payload,
  };
}

export const onDoRequestAmendOrder = payload => (dispatch) => {
  dispatch(onRequestAmendOrder());
  Fetch.post(`${V1}stock/amend/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestAmendOrderSuccess(resp.json));
      } else {
        dispatch(onRequestAmendOrderFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestAmendOrderFailure(error.message));
    });
};

//= ==================================================================================//
//                              HISTORY FREE STOCK                                    //
//= ==================================================================================//

const ON_REQUEST_HISTORY_BONUS_STOCK = 'ON_REQUEST_HISTORY_BONUS_STOCK';
const ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS = 'ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS';
const ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE = 'ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE';

function onRequestHistoryBonusStock(resetData) {
  return {
    type: ON_REQUEST_HISTORY_BONUS_STOCK,
    meta: { resetData },
  };
}

function onRequestHistoryBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestHistoryBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestGetHistoryBonusStock = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestHistoryBonusStock(resetData));
  Fetch.get(`${V1}stock/bonus/sell/matched/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestHistoryBonusStockSuccess(resp.json));
      } else {
        dispatch(onRequestHistoryBonusStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestHistoryBonusStockFailure(error.message));
    });
};

//= ==================================================================================//
//                                   OPEN                                             //
//= ==================================================================================//

const ON_REQUEST_ORDER_BONUS_STOCK = 'ON_REQUEST_ORDER_BONUS_STOCK';
const ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS = 'ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS';
const ON_REQUEST_ORDER_BONUS_STOCK_FAILURE = 'ON_REQUEST_ORDER_BONUS_STOCK_FAILURE';

function onRequestOrderBonusStock(resetData) {
  return {
    type: ON_REQUEST_ORDER_BONUS_STOCK,
    meta: { resetData },
  };
}

function onRequestOrderBonusStockSuccess(payload) {
  return {
    type: ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS,
    payload,
  };
}

function onRequestOrderBonusStockFailure(payload) {
  return {
    type: ON_REQUEST_ORDER_BONUS_STOCK_FAILURE,
    payload,
  };
}

export const onDoRequestGetOrderBonusStock = (payload, resetData = false) => (
  dispatch
) => {
  dispatch(onRequestOrderBonusStock(resetData));
  Fetch.get(`${V1}stock/bonus/sell/${payload}`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestOrderBonusStockSuccess(resp.json));
      } else {
        dispatch(onRequestOrderBonusStockFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestOrderBonusStockFailure(error.message));
    });
};

//= ==================================================================================//
//                           DETAIL FREE STOCK                                        //
//= ==================================================================================//

const ON_GET_FREE_STOCK_DETAIL = 'ON_GET_FREE_STOCK_DETAIL';
const ON_GET_FREE_STOCK_DETAIL_SUCCESS = 'ON_GET_FREE_STOCK_DETAIL_SUCCESS';
const ON_GET_FREE_STOCK_DETAIL_FAILURE = 'ON_GET_FREE_STOCK_DETAIL_FAILURE';

function onGetFreeStockDetail() {
  return {
    type: ON_GET_FREE_STOCK_DETAIL,
  };
}

function onGetFreeStockDetailSuccess(payload) {
  return {
    type: ON_GET_FREE_STOCK_DETAIL_SUCCESS,
    payload,
  };
}

function onGetFreeStockDetailFailure(payload) {
  return {
    type: ON_GET_FREE_STOCK_DETAIL_FAILURE,
    payload,
  };
}

export const onDoGetFreeStockDetail = payload => (dispatch) => {
  dispatch(onGetFreeStockDetail());
  Fetch.get(`${V1}stock/bonus/sell/detail/${payload}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetFreeStockDetailSuccess(resp.json));
      } else {
        dispatch(onGetFreeStockDetailFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetFreeStockDetailFailure(error.message));
    });
};

const INITIAL_STATE = {
  transactionStockLoading: null,
  transactionStockData: null,
  transactionStockError: null,

  transactionStockOpenLoading: null,
  transactionStockOpenData: null,
  transactionStockOpenError: null,

  transactionStockDetailLoading: null,
  transactionStockDetailData: null,
  transactionStockDetailError: null,

  historyStockLoading: null,
  historyStockData: null,
  historyStockError: null,

  historyDetailLoading: null,
  historyDetailData: null,
  historyDetailError: null,

  cancelOrderLoading: null,
  cancelOrderSuccess: null,
  cancelOrderError: null,

  amendOrderLoading: null,
  amendOrderSuccess: null,
  amendOrderError: null,

  transactionFreeStockLoading: null,
  transactionFreeStockData: null,
  transactionFreeStockError: null,

  historyFreeStockLoading: null,
  historyFreeStockData: null,
  historyFreeStockError: null,

  transactionFreeStockDetailLoading: null,
  transactionFreeStockDetailData: null,
  transactionFreeStockDetailError: null,
};

const transaction = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_TRANSACTION_STOCK:
      if (action.meta.resetData) {
        return {
          ...state,
          transactionStockLoading: true,
          transactionStockData: null,
          transactionStockError: null,
        };
      } 
        return {
          ...state,
          transactionStockLoading: true,
          transactionStockError: null,
        };
      
    case ON_REQUEST_TRANSACTION_STOCK_SUCCESS:
      if (!action.meta.resetData && state.transactionStockData) {
        const oldResults = [...state.transactionStockData.result.results];
        state.transactionStockData = {
          result: {
            ...action.payload.result,
            results: [...oldResults, ...action.payload.result.results],
          },
        };
      } else {
        state.transactionStockData = action.payload;
      }
      return {
        ...state,
        transactionStockLoading: false,
        transactionStockError: null,
      };
    case ON_REQUEST_TRANSACTION_STOCK_FAILURE:
      return {
        ...state,
        transactionStockLoading: false,
        transactionStockError: action.payload,
      };
    case ON_REQUEST_TRANSACTION_STOCK_OPEN:
      if (action.meta.resetData) {
        return {
          ...state,
          transactionStockOpenLoading: true,
          transactionStockOpenData: null,
          transactionStockOpenError: null,
        };
      } 
        return {
          ...state,
          transactionStockOpenLoading: true,
          transactionStockOpenError: null,
        };
      
    case ON_REQUEST_TRANSACTION_STOCK_OPEN_SUCCESS:
      if (!action.meta.resetData && state.transactionStockOpenData) {
        const oldResults = [...state.transactionStockOpenData.result.results];
        state.transactionStockOpenData = {
          result: {
            ...action.payload.result,
            results: [...oldResults, ...action.payload.result.results],
          },
        };
      } else {
        state.transactionStockOpenData = action.payload;
      }
      return {
        ...state,
        transactionStockOpenLoading: false,
        transactionStockOpenError: null,
      };
    case ON_REQUEST_TRANSACTION_STOCK_OPEN_FAILURE:
      return {
        ...state,
        transactionStockOpenLoading: false,
        transactionStockOpenError: action.payload,
      };
    case ON_REQUEST_TRANSACTION_STOCK_DETAIL:
      return {
        ...state,
        transactionStockDetailLoading: true,
        transactionStockDetailData: null,
        transactionStockDetailError: null,
      };
    case ON_REQUEST_TRANSACTION_STOCK_DETAIL_SUCCESS:
      return {
        ...state,
        transactionStockDetailLoading: false,
        transactionStockDetailData: action.payload,
        transactionStockDetailError: null,
      };
    case ON_REQUEST_TRANSACTION_STOCK_DETAIL_FAILURE:
      return {
        ...state,
        transactionStockDetailLoading: false,
        transactionStockDetailData: null,
        transactionStockDetailError: action.payload,
      };
    case ON_REQUEST_HISTORY_STOCK:
      if (action.meta.resetData) {
        return {
          ...state,
          historyStockLoading: true,
          historyStockData: null,
          historyStockError: null,
        };
      } 
        return {
          ...state,
          historyStockLoading: true,
          historyStockError: null,
        };
      
    case ON_REQUEST_HISTORY_STOCK_SUCCESS:
      if (state.historyStockData) {
        const oldResults = [...state.historyStockData.result.results];
        state.historyStockData = {
          ...action.payload,
          result: {
            count: action.payload.result.count,
            results: [...oldResults, ...action.payload.result.results],
          },
        };
      } else {
        state.historyStockData = action.payload;
      }
      return {
        ...state,
        historyStockLoading: false,
        historyStockError: null,
      };
    case ON_REQUEST_HISTORY_STOCK_FAILURE:
      return {
        ...state,
        historyStockLoading: false,
        historyStockError: action.payload,
      };
    case ON_REQUEST_HISTORY_STOCK_DETAIL:
      return {
        ...state,
        historyDetailLoading: true,
        historyDetailData: null,
        historyDetailError: null,
      };
    case ON_REQUEST_HISTORY_STOCK_DETAIL_SUCCESS:
      return {
        ...state,
        historyDetailLoading: false,
        historyDetailData: action.payload,
        historyDetailError: null,
      };
    case ON_REQUEST_HISTORY_STOCK_DETAIL_FAILURE:
      return {
        ...state,
        historyDetailLoading: false,
        historyDetailData: null,
        historyDetailError: action.payload,
      };
    case ON_REQUEST_CANCEL_ORDER:
      return {
        ...state,
        cancelOrderLoading: true,
        cancelOrderSuccess: null,
        cancelOrderError: null,
      };
    case ON_REQUEST_CANCEL_ORDER_SUCCESS:
      return {
        ...state,
        cancelOrderLoading: false,
        cancelOrderSuccess: action.payload,
        cancelOrderError: null,
      };
    case ON_REQUEST_CANCEL_ORDER_FAILURE:
      return {
        ...state,
        cancelOrderLoading: false,
        cancelOrderSuccess: null,
        cancelOrderError: action.payload,
      };
    case ON_REQUEST_AMEND_ORDER:
      return {
        ...state,
        amendOrderLoading: true,
        amendOrderSuccess: null,
        amendOrderError: null,
      };
    case ON_REQUEST_AMEND_ORDER_SUCCESS:
      return {
        ...state,
        amendOrderLoading: false,
        amendOrderSuccess: action.payload,
        amendOrderError: null,
      };
    case ON_REQUEST_AMEND_ORDER_FAILURE:
      return {
        ...state,
        amendOrderLoading: false,
        amendOrderSuccess: null,
        amendOrderError: action.payload,
      };
    case ON_REQUEST_HISTORY_BONUS_STOCK:
      if (action.meta.resetData) {
        return {
          ...state,
          historyFreeStockLoading: true,
          historyFreeStockData: null,
          historyFreeStockError: null,
        };
      } 
        return {
          ...state,
          historyFreeStockLoading: true,
          historyFreeStockError: null,
        };
      
    case ON_REQUEST_HISTORY_BONUS_STOCK_SUCCESS:
      if (state.historyFreeStockData) {
        const oldResults = [...state.historyFreeStockData.results];
        state.historyFreeStockData = {
          ...action.payload,
          count: action.payload.count,
          results: [...oldResults, ...action.payload.results],
        };
      } else {
        state.historyFreeStockData = action.payload;
      }
      return {
        ...state,
        historyFreeStockLoading: false,
        historyFreeStockError: null,
      };
    case ON_REQUEST_HISTORY_BONUS_STOCK_FAILURE:
      return {
        ...state,
        historyFreeStockLoading: false,
        historyFreeStockError: action.payload,
      };

    case ON_REQUEST_ORDER_BONUS_STOCK:
      if (action.meta.resetData) {
        return {
          ...state,
          transactionFreeStockLoading: true,
          transactionFreeStockData: null,
          transactionFreeStockError: null,
        };
      } 
        return {
          ...state,
          transactionFreeStockLoading: true,
          transactionFreeStockError: null,
        };
      
    case ON_REQUEST_ORDER_BONUS_STOCK_SUCCESS:
      if (state.transactionFreeStockData) {
        const oldResults = [...state.transactionFreeStockData.results];
        state.transactionFreeStockData = {
          ...action.payload,
          count: action.payload.count,
          results: [...oldResults, ...action.payload.results],
        };
      } else {
        state.transactionFreeStockData = action.payload;
      }
      return {
        ...state,
        transactionFreeStockLoading: false,
        transactionFreeStockError: null,
      };
    case ON_REQUEST_ORDER_BONUS_STOCK_FAILURE:
      return {
        ...state,
        transactionFreeStockLoading: false,
        transactionFreeStockError: action.payload,
      };
    case ON_GET_FREE_STOCK_DETAIL:
      return {
        ...state,
        transactionFreeStockDetailLoading: true,
        transactionFreeStockDetailData: null,
        transactionFreeStockDetailError: null,
      };
    case ON_GET_FREE_STOCK_DETAIL_SUCCESS:
      return {
        ...state,
        transactionFreeStockDetailLoading: false,
        transactionFreeStockDetailData: action.payload,
        transactionFreeStockDetailError: null,
      };
    case ON_GET_FREE_STOCK_DETAIL_FAILURE:
      return {
        ...state,
        transactionFreeStockDetailLoading: false,
        transactionFreeStockDetailData: null,
        transactionFreeStockDetailError: action.payload,
      };
    default:
      return state;
  }
};

export default transaction;
